import { useEffect } from "react";
import { isDeltaAirlinesOffer } from "../components/elements/FlightCard/utils.js";
import flights_apex_web_delta_airlines_pilot_2026 from "../utils/experiments/apex/flights_apex_web_delta_airlines_pilot_2026.js";
import flights_web_delta_airlines_pilot_phase_2 from "../utils/experiments/apex/flights_web_delta_airlines_pilot_phase_2.js";
const useTrackDeltaFlightDetailsGoal = (flight) => {
    useEffect(() => {
        if (flight && isDeltaAirlinesOffer(flight)) {
            flights_apex_web_delta_airlines_pilot_2026.goals.dl_offer_flight_details();
            flights_web_delta_airlines_pilot_phase_2.goals.dl_offer_flight_details();
        }
    }, [flight]);
};
export default useTrackDeltaFlightDetailsGoal;
